<div class="file-field">
  <!-- Existing file display -->
  <nb-card *ngIf="fileUrl" size="small" status="basic" class="existing-file-card mb-3">
    <nb-card-body class="p-2">
      <div class="d-flex align-items-center">
        <!-- Preview for images -->
        <div class="preview-container mr-0" *ngIf="isImage()">
          <img [src]="previewDataUrl || fileUrl" 
               alt="preview" 
               class="file-preview-image"/>
        </div>
        
        <!-- File icon for non-images -->
        <div class="file-icon-container mr-0" *ngIf="!isImage()">
          <nb-icon icon="file-text-outline" 
                   status="basic" 
                   [options]="{ animation: { type: 'pulse' } }">
          </nb-icon>
        </div>

        <!-- File info -->
        <!-- <div class="file-info flex-grow-1">
          <div class="file-name">
            <nb-icon icon="attach-outline" class="mr-1"></nb-icon>
            <strong>{{ fileName || 'Uploaded file' }}</strong>
          </div>
          <div class="file-meta text-hint" *ngIf="fileUrl">
            <small>{{ fileUrl | slice:0:60 }}{{ fileUrl?.length > 60 ? '...' : '' }}</small>
          </div>
        </div> -->

        <!-- Actions -->
        <div class="file-actions ml-2">
          <button nbButton 
                  size="small" 
                  status="info" 
                  (click)="view()" 
                  nbTooltip="View file"
                  nbTooltipPlacement="top">View
            <nb-icon icon="eye-outline"></nb-icon>
          </button>
          <button nbButton 
                  size="small" 
                  status="danger" 
                  outline 
                  (click)="remove()" 
                  class="ml-2"
                  *ngIf="isEditable"
                  nbTooltip="Remove file"
                  nbTooltipPlacement="top">
            <nb-icon icon="trash-2-outline"></nb-icon>
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Read-only state (no file) -->
  <div *ngIf="!fileUrl && !isEditable" class="empty-state">
    <nb-alert status="basic" size="small" class="text-muted">
      <nb-icon icon="file-remove-outline" status="basic" class="mr-2 text-muted"></nb-icon>
      No file uploaded
    </nb-alert>
  </div>

  <!-- Upload controls (editable mode) -->
  <nb-card *ngIf="isEditable && !uploading && !fileUrl" size="small" status="basic" class="upload-card">
    <nb-card-body class="p-2">
      <div class="upload-area">
        <div class="upload-icon-container text-center mb-2">
          <nb-icon icon="cloud-upload-outline" 
                   status="basic" 
                   [options]="{ animation: { type: 'shake' } }">
          </nb-icon>
        </div>
        
        <div class="upload-controls d-flex align-items-center">
          <input #fileInput
                 type="file" 
                 (change)="onFileSelected($event)" 
                 [attr.accept]="accept"
                 class="file-input"
                 id="file-upload-input"/>
          
          <label for="file-upload-input" class="flex-grow-1">
            <button nbButton 
                    fullWidth
                    size="medium" 
                    status="basic" 
                    outline
                    type="button"
                    (click)="fileInput.click()">
              <nb-icon icon="folder-outline" status="basic" class="mr-2"></nb-icon>
              {{ selectedFile ? selectedFile.name : 'Choose file' }}
            </button>
          </label>
          
          <button nbButton 
                  size="medium" 
                  status="primary" 
                  class="ml-2"
                  [disabled]="!selectedFile"
                  (click)="upload()"
                  nbTooltip="Upload file"
                  nbTooltipPlacement="top">
            <nb-icon icon="upload-outline"></nb-icon>
            Upload
          </button>
        </div>

        <div class="upload-hint text-hint text-center mt-2" *ngIf="!selectedFile">
          <small>
            <nb-icon icon="info-outline" class="mr-1"></nb-icon>
            {{ accept ? 'Accepted: ' + accept : 'Select a file to upload' }}
          </small>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Upload progress -->
  <nb-card *ngIf="uploading" size="small" status="info" class="upload-progress-card">
    <nb-card-body>
      <div class="upload-progress-content">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <span class="uploading-text">
            <nb-icon icon="loader-outline" 
                     [options]="{ animation: { type: 'spin' } }">
            </nb-icon>
            <strong class="ml-2">Uploading...</strong>
          </span>
          <span class="progress-percentage">{{ progress }}%</span>
        </div>
        
        <nb-progress-bar [value]="progress" 
                         status="info" 
                         [displayValue]="false"
                         size="medium">
        </nb-progress-bar>

        <div class="uploading-file-name text-hint mt-2">
          <small>{{ selectedFile?.name }}</small>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>